export enum EBankAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}
